class RegisterForm extends window.BAO.CustomElement({
  SuperClass: HTMLFormElement,
}) {
  static get requiredElements () {
    return ['terms', 'terms-error']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'submit', this.onSubmitHandler.bind(this))

    this.listeners.add(
      this.els.terms.element,
      'change',
      this.onCheckboxChangeHandler.bind(this),
    )
  }

  onSubmitHandler (e) {
    const terms = this.els.terms.element

    if (terms.checked) {
      this.els['terms-error'].element.setAttribute('aria-hidden', true)
      return
    }

    e.preventDefault()

    this.els['terms-error'].element.setAttribute('aria-hidden', false)
  }

  onCheckboxChangeHandler (e) {
    if (e.currentTarget.checked) {
      this.els['terms-error'].element.setAttribute('aria-hidden', true)
    } else {
      this.els['terms-error'].element.setAttribute('aria-hidden', false)
    }
  }
}

if (!customElements.get('register-form')) {
  customElements.define('register-form', RegisterForm, { extends: 'form' })
}
